<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="combinedAudits && combinedAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="combinedAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Aircraft Event audits </ng-template>

  <mat-accordion>
    <mat-expansion-panel
      *ngFor="let aircraftEventBusinessPerson of aircraftEvent.aircraftEventBusinessPersons"
      (opened)="aircraftEventBusinessPersonOpened(aircraftEventBusinessPerson)"
    >
      <mat-expansion-panel-header>
        <div *ngIf="aircraftEventBusinessPerson.isDeleted; else notDeleted">
          {{ aircraftEventBusinessPerson.aircraftEventBusinessPersonId }}&nbsp;(Deleted)
        </div>
        <ng-template #notDeleted>
          {{ aircraftEventBusinessPerson.businessPersonName }} -
          {{
            getFlightBusinessPersonTypeName(
              flightBusinessPersonTypes,
              aircraftEventBusinessPerson.flightBusinessPersonTypeId
            )
          }}
        </ng-template>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>
        <sd-portal-aircraft-event-business-person-audit-list
          #aircraftEventBusinessPersonAuditList
          [aircraftEventBusinessPerson]="aircraftEventBusinessPerson"
          [loading]="aircraftEventBusinessPersonLoading"
          [aircraftEventBusinessPersonAudits]="aircraftEventBusinessPersonAudits"
          (loadAircraftEventBusinessPerson)="loadAircraftEventBusinessPerson.emit($event)"
          (nextPage)="loadNextAircraftEventBusinessPersonPage.emit($event)"
        >
        </sd-portal-aircraft-event-business-person-audit-list>
      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</ng-template>
